export default {
    apiKey: "AIzaSyD2TPQr1-OVc084xvMyQmwPp1g2ijJUaRo",
    authDomain: "worble-game.firebaseapp.com",
    projectId: "worble-game",
    storageBucket: "worble-game.appspot.com",
    messagingSenderId: "228499433397",
    appId: "1:228499433397:web:04b8997ee4cf23be881bfc",
    measurementId: "G-30V1DLCW52"
}